import { UserDto } from '@flagsync/skyline';
import { IconUserCheck } from '@tabler/icons-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

import { AuthTemplate } from '@/pages/unauthenticated/auth/components';

export const Welcome = ({
  organizationName,
  user,
}: {
  organizationName: string;
  user: UserDto | undefined;
}) => {
  return (
    <AuthTemplate
      heading={
        <div className="flex items-center justify-center">
          <IconUserCheck className="mr-2" />
          Welcome to FlagSync
        </div>
      }
    >
      <div className="space-y-4">
        <div className="text-sm">
          You&apos;ve join the{' '}
          <span className="font-semibold">{organizationName}</span> team.
        </div>
        {user ? (
          <Button className="w-full mt-2" asChild>
            <Link to="/dashboard">Take me to the dashboard</Link>
          </Button>
        ) : (
          <Button className="w-full mt-2" asChild>
            <Link to="/login">Sign in</Link>
          </Button>
        )}
      </div>
    </AuthTemplate>
  );
};
